import { useMemo } from "react";
import type { AppearanceSettings } from "../types/brand";

export interface ChangedFields {
  theme: boolean;
  socialMediaIconSizes: boolean;
  primayColour: boolean;
  secondaryColour: boolean;
  imageIds: boolean;
  showcaseProductIds: boolean;
  joinText: boolean;
  joinTitle: boolean;
  ambassadorText: boolean;
}

export const useAppearanceHighlight = (
  currentSettings:
    | AppearanceSettings
    | Partial<AppearanceSettings>
    | null
    | undefined,
  originalSettings: AppearanceSettings | null
): ChangedFields => {
  return useMemo(() => {
    if (!currentSettings || !originalSettings) {
      return {
        theme: false,
        socialMediaIconSizes: false,
        primayColour: false,
        secondaryColour: false,
        imageIds: false,
        showcaseProductIds: false,
        joinText: false,
        joinTitle: false,
        ambassadorText: false,
      };
    }

    return {
      theme: currentSettings.theme !== originalSettings.theme,
      socialMediaIconSizes:
        currentSettings.socialMediaIconSizes !==
        originalSettings.socialMediaIconSizes,
      primayColour:
        currentSettings.primayColour !== originalSettings.primayColour,
      secondaryColour:
        currentSettings.secondaryColour !== originalSettings.secondaryColour,
      imageIds:
        JSON.stringify(currentSettings.imageIds) !==
        JSON.stringify(originalSettings.imageIds),
      showcaseProductIds:
        JSON.stringify(currentSettings.showcaseProductIds) !==
        JSON.stringify(originalSettings.showcaseProductIds),
      joinText: currentSettings.joinText !== originalSettings.joinText,
      joinTitle: currentSettings.joinTitle !== originalSettings.joinTitle,
      ambassadorText:
        currentSettings.ambassadorText !== originalSettings.ambassadorText,
    };
  }, [currentSettings, originalSettings]);
};

